import { render, staticRenderFns } from "./RecordSnapshotDialog.vue?vue&type=template&id=b83b9a52&scoped=true"
import script from "./RecordSnapshotDialog.vue?vue&type=script&lang=js"
export * from "./RecordSnapshotDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordSnapshotDialog.vue?vue&type=style&index=0&id=b83b9a52&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83b9a52",
  null
  
)

export default component.exports